var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTryAgain(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.78125 6.34375C2.59375 6.875 2 7.15625 1.5 6.96875C0.96875 6.78125 0.6875 6.21875 0.875 5.6875C1.21875 4.71875 1.78125 3.8125 2.53125 3.0625C5.28125 0.34375 9.6875 0.34375 12.4375 3.0625L12.9688 3.625V2C12.9688 1.46875 13.4375 1 13.9688 1C14.5312 1 14.9688 1.46875 14.9688 2V6C14.9688 6.5625 14.5312 7 13.9688 7H10C9.4375 7 9 6.5625 9 6C9 5.46875 9.4375 5 10 5H11.5625L11.0312 4.46875C9.0625 2.53125 5.90625 2.53125 3.9375 4.46875C3.40625 5.03125 3 5.65625 2.78125 6.34375ZM0.71875 9.0625C0.75 9.03125 0.8125 9.03125 0.84375 9.03125C0.90625 9.03125 0.9375 9 1 9H5C5.53125 9 6 9.46875 6 10C6 10.5625 5.53125 11 5 11H3.40625L3.9375 11.5625C5.90625 13.5 9.0625 13.5 11.0312 11.5625C11.5625 11 11.9688 10.375 12.1875 9.6875C12.375 9.15625 12.9688 8.875 13.4688 9.0625C14 9.25 14.2812 9.8125 14.0938 10.3438C13.75 11.3125 13.1875 12.1875 12.4375 12.9688C9.6875 15.6875 5.28125 15.6875 2.53125 12.9688L2 12.4062V14C2 14.5625 1.53125 15 1 15C0.4375 15 0 14.5625 0 14V10.0312C0 9.96875 0 9.90625 0 9.875C0 9.8125 0 9.78125 0.03125 9.75C0.0625 9.59375 0.15625 9.4375 0.28125 9.3125C0.40625 9.1875 0.5625 9.09375 0.71875 9.0625Z",
    fill: "#D8D8D9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTryAgain);
export default __webpack_public_path__ + "static/media/try_again.4463ad4f7ef339d4f340c5f79abb4f77.svg";
export { ForwardRef as ReactComponent };